import axios from 'axios';
import { ConfirmCapturesFileRequest } from '../../../types/interfaces/file/imports/captures';
import { SessionStore } from '../../../types/store';
import { newAbortSignal } from '../../../utils';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures/upload/confirm`;

export const confirmCapturesFile = async (
  confirmInfo: ConfirmCapturesFileRequest
): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const res = await axios.post(BASE_URL, confirmInfo, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
